<template>
  <component
    class="tgb-button"
    :class="variantType"
    :type="type"
    :is="btnType"
    :href="href"
    :to="to"
    @click="click"
  >
    <span>
      <slot />
    </span>
  </component>
</template>

<script>
export default {
  name: 'TgbButton',

  methods: {
    click() {
      this.$emit('click');
    },
  },

  props: {
    variant: {
      type: String,
      default: 'primary',
    },

    type: {
      type: String,
      default: 'button',
    },

    href: {
      type: String,
      default: '',
    },

    to: {
      type: String,
      default: '',
    },
  },

  computed: {
    variantType() {
      return `tgb-button--${this.variant}`;
    },

    btnType() {
      if (this.href) {
        return 'a';
      }

      if (this.to) {
        return 'router-link';
      }

      return 'button';
    },
  },
};
</script>

<style lang="scss">
.tgb-button {
  padding: 10px 15px;
  font-weight: 700;
  font-family: Barlow, sans-serif;
  font-style: normal;
  font-size: 14px;
  cursor: pointer;
}

.tgb-button--primary {
  color: #fff;
  border: #007F9D;
  border-radius: 2px;
  background-color: #007F9D;

  &:hover {
    background: #109BB8;
    border-color: #109BB8;
  }

  &:active {
    background: #2BACCA;
    border-color: #2BACCA;
  }

  &:disabled {
    color: #333333;
    border-color: #6D7D85;
    background-color: #6D7D85;
  }
}

.tgb-button--secondary {
  color: #23CDF4;
  border: 1px solid;
  border-radius: 2px;
  border-color: #23CDF4;
  background-color: #1B2224;

  &:hover {
    color: #56DFFF;
    border-color: #56DFFF;
  }

  &:active {
    color: #B2F1FF;
    border-color: #B2F1FF;
  }

  &:disabled {
    color: #808689;
    border-color: #388091;
  }
}

.tgb-button--tertiary {
  color: #FFFFFF;
  background: 0 0;
  border: 0;

  &:hover {
    color: #95EBFF;
  }
  &:active {
    color: #B2F1FF;
  }
  &:disabled {
    color: #808689;
  }
}

.tgb-button--primaryDanger {
  color: #FFFFFF;
  background: #B22000;
  border: #B22000;
  border-radius: 2px;

  &:hover {
    background: #A70A00;
    border: #A70A00;
  }
  &:active {
    background: #901A1A;
    border: #901A1A;
  }
}

.tgb-button--secondaryDanger {
  color: #FFFFFF;
  border: 1px solid;
  border-color: #FFFFFF;
  border-radius: 2px;
  background-color: #1B2224;

  &:hover {
    border-color: #FF766D;
  }
  &:active {
    background: #901A1A;
    border-color: #901A1A;
  }
}
</style>
